export const DAY_NAMES = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
];

export const GRID_START_MINUTES = 7 * 60;
export const GRID_END_MINUTES = 22 * 60;
export const SLOT_MINUTES = 30;

export function timeToMinutes(value) {
    const match = /^(\d{2}):(\d{2})$/.exec(value || "");
    if (!match) return null;

    const hours = Number(match[1]);
    const minutes = Number(match[2]);
    if (hours > 23 || minutes > 59) return null;
    return hours * 60 + minutes;
}

export function minutesToTime(value) {
    const hours = Math.floor(value / 60);
    const minutes = value % 60;
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
}

export function mergeAvailabilityWindows(windows = []) {
    const validWindows = windows
        .map((window) => ({
            start_time: window?.start_time ?? "",
            end_time: window?.end_time ?? "",
        }))
        .filter((window) => {
            const start = timeToMinutes(window.start_time);
            const end = timeToMinutes(window.end_time);
            return start !== null && end !== null && start < end;
        })
        .sort((first, second) => timeToMinutes(first.start_time) - timeToMinutes(second.start_time));

    return validWindows.reduce((merged, window) => {
        const previous = merged[merged.length - 1];
        if (!previous || timeToMinutes(window.start_time) > timeToMinutes(previous.end_time)) {
            merged.push({ ...window });
            return merged;
        }

        if (timeToMinutes(window.end_time) > timeToMinutes(previous.end_time)) {
            previous.end_time = window.end_time;
        }
        return merged;
    }, []);
}

export function toWeeklyAvailabilityDays(weeklyData = []) {
    return DAY_NAMES.map((_, dayOfWeek) => {
        const match = weeklyData.find((item) => Number(item?.day_of_week) === dayOfWeek);
        const legacy = match?.regular ?? match;
        let windows = Array.isArray(match?.windows) ? match.windows : [];

        if (windows.length === 0 && legacy?.active && legacy?.start_time && legacy?.end_time) {
            windows = [{ start_time: legacy.start_time, end_time: legacy.end_time }];
        }

        return {
            day_of_week: dayOfWeek,
            windows: mergeAvailabilityWindows(windows),
        };
    });
}